import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/challenges/$pageSlug")({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === "string" ? search.from : undefined,
  }),
});
